import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./SupportPlanModal.css";
import {
  getSencoReportByStudentId,
  upsertSencoReport,
} from "../services/APIClient";

const supportOptions = [
  { text: "Individual", color: "purple" },
  { text: "Group", color: "purple" },
  { text: "Team Teaching", color: "purple" },
  { text: "Literacy", color: "purple" },
  { text: "Oral Language", color: "purple" },
  { text: "Social Skills", color: "purple" },
  { text: "Attention and Concentration", color: "purple" },
  { text: "Assistive Technology", color: "purple" },
  { text: "Comprehension", color: "purple" },
  { text: "Motor Skills", color: "purple" },
  { text: "Self-Esteem", color: "purple" },
  { text: "Confidence", color: "purple" },
];

const DetailsOfSetReceivedModal = ({
  show,
  handleClose,
  studentName,
  // setReceived,
  // setSetReceived,
  // handleSaveChanges,
  currentStudentId,
  teacherid,
  callClassName,
  setName,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [setReceived, setSetReceived] = useState([]);

  useEffect(() => {
    if (show && currentStudentId) {
      getSencoReportByStudentId(currentStudentId)
        .then((response) => {
          if (response && response.setreceived !== undefined) {
            setSetReceived(response.setreceived);
            setSelectedOptions(response.setreceived || []); // Pre-select the options if available
          } else {
            setSetReceived([]);
            setSelectedOptions([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching literacy observations:", error);
          setSetReceived([]);
          setSelectedOptions([]);
        });
    }
  }, [show, currentStudentId, setSetReceived]);

  const handleOptionClick = (text) => {
    const updatedOptions = selectedOptions.includes(text)
      ? selectedOptions.filter((option) => option !== text)
      : [...selectedOptions, text];
    setSelectedOptions(updatedOptions);
    setSetReceived(updatedOptions);
    console.log(`Selected options for ${studentName}:`, updatedOptions);
  };

  const saveChanges = () => {
    handleSaveChanges();
    handleClose();
  };

  const handleModalClose = () => {
    setSelectedOptions([]); // Reset selected options to an empty array
    handleClose();
  };

  const handleSaveChanges = () => {
    const reportData = {
      studentid: currentStudentId,
      teacherid: teacherid,
      setreceived: setReceived,
      setname: setName,
      classname: callClassName,
    };

    if (currentStudentId) {
      // setLastSavedStudentId(currentStudentId); // Update last saved student ID
      // resetStateVariables();
      upsertSencoReport(reportData)
        .then((response) => {
          // Reset only if saving for a different student
          console.log("Upsert JISI Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      console.error("Error: No student selected.");
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ textAlign: "center", width: "100%" }}>
          Details Of SET Received
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="options-container">
          {supportOptions.map((option) => (
            <div
              key={option.text}
              className={`option ${option.color} ${
                (selectedOptions || []).includes(option.text) ? "selected" : ""
              }`}
              onClick={() => handleOptionClick(option.text)}
            >
              {option.text}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          variant="secondary"
          className="modal-button no-button"
          onClick={handleModalClose}
        >
          Cancel
        </button>
        <button
          variant="primary"
          className="modal-button yes-button"
          onClick={saveChanges}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailsOfSetReceivedModal;
